// Общий кэш Blob URL для превью PDF.
//
// Раньше PdfView.jsx (pdfCache) и DocView.jsx (docxCache) держали ОТДЕЛЬНЫЕ
// Map с одинаковой логикой fetch+Blob, а фоновая предзагрузка страниц
// (PreloadDocumentPages.jsx, используется в EditManyDocs.jsx при выборе
// нескольких документов) шла ДРУГИМ, менее надёжным путём — напрямую через
// <Document file={url} options={{ httpHeaders: {...} }}>, полагаясь на
// внутренний сетевой слой pdf.js вместо обычного fetch(). Именно поэтому
// фоновая предзагрузка молча не срабатывала: цена по умолчанию не
// считалась (пока страницы неизвестны, EditManyDocs.jsx подставляет 1),
// а кнопка оплаты не включалась (canPrint требует docRendered=true для
// КАЖДОГО документа), пока пользователь не открывал каждый документ вручную.
//
// Общий модуль для всех потребителей (PdfView/DocView/PreloadDocumentPages)
// даёт два эффекта разом: предзагрузка становится такой же надёжной, как уже
// работающий прямой просмотр, и повторное открытие уже предзагруженного
// документа не бьёт в сеть второй раз — блоб уже готов.
const cache = new Map(); // url -> Promise<blobUrl>

const FETCH_TIMEOUT_MS = 15000;

export function fetchPdfBlob(url, accessToken) {
    if (cache.has(url)) return cache.get(url);

    const promise = (async () => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
        try {
            const response = await fetch(url, {
                mode: "cors",
                signal: controller.signal,
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!response.ok) {
                throw new Error(`HTTP ${response.status} ${response.statusText}`);
            }
            const arrayBuffer = await response.arrayBuffer();
            const blob = new Blob([arrayBuffer], { type: "application/pdf" });
            return URL.createObjectURL(blob);
        } finally {
            clearTimeout(timeoutId);
        }
    })();

    // Неудачу не кэшируем — следующий вызов (ручной повтор, повторный выбор
    // документа) получит шанс попробовать снова, а не застрянет на старой ошибке.
    promise.catch(() => cache.delete(url));

    cache.set(url, promise);
    return promise;
}
